import React, { useState } from 'react';
import { getPropertyDataById } from '../../../services/productSaveService';
import { propertyNamesService } from '../../../services/propertyNamesService';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../Checkbox';

const ProductPropertyBoolean = ({ propertyId, itemSaveService }) => {
    const { i18n } = useTranslation();
    const [checkedValue, setCheckedValue] = useState(propertyId ? getPropertyDataById(propertyId).value : itemSaveService.getProperty().value);

    const editFieldValue = (checked) => {
        setCheckedValue(checked);
        itemSaveService.updateProductProperty(propertyId, 'value', checked.toString());
    };

    const isChecked = checkedValue === 'true' || checkedValue === true;

    return (
        <label className="block__content product__label-checkbox flex items-center gap-8">
            <span className="product__add-checkbox-text">
                {propertyNamesService.getLocalization(
                    i18n.resolvedLanguage,
                    propertyId ? getPropertyDataById(propertyId) : { propertyName: itemSaveService.getProperty().itemCode },
                    true,
                    i18n,
                )}
            </span>
            <Checkbox checked={isChecked} handleChecked={editFieldValue} />
        </label>
    );
};

export default ProductPropertyBoolean;
